import React, { forwardRef, useImperativeHandle } from "react";
import { Form, Input } from "antd";

const formItemLayout = {
  labelCol: { span: 4, offset: 2 },
  wrapperCol: { span: 18 }
};

const AddFoodProductsForm = forwardRef(({ form, editingPersonInfo }, ref) => {
  const { getFieldDecorator } = form;
  useImperativeHandle(ref, () => ({
    form
  }));
  return (
    <Form
      layout={"horizontal"}
      className="add-person-form"
      id="add-person-form"
      hideRequiredMark={true}
    >
      <Form.Item
        label="Наименование:"
        {...formItemLayout}
        style={{ marginBottom: 10 }}
      >
        {getFieldDecorator("food_product_name", {
          rules: [
            {
              required: true,
              message: "Поле, обязательное для заполнения"
            }
          ]
        })(
          <Input style={{ width: 368 }} placeholder={"Укажите наименование"} />
        )}
      </Form.Item>
      <Form.Item
        label="Вес или объем:"
        {...formItemLayout}
        style={{ marginBottom: 10 }}
      >
        {getFieldDecorator("food_product_volume", {
          rules: [
            {
              required: true,
              message: "Поле, обязательное для заполнения"
            }
          ]
        })(
          <Input style={{ width: 224 }} placeholder={"Укажите вес или объем"} />
        )}
      </Form.Item>
    </Form>
  );
});

const WrappedAddPersonForm = Form.create({ name: "add_person_form" })(
  AddFoodProductsForm
);

export default WrappedAddPersonForm;
